import GetLocationsRequestModelBase from '../_generated/modelBases/get-locations-request-model-base';

export default class GetLocationsRequestModel extends GetLocationsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
